/**
 * X-Z平面で2つのベクトルから成す角を0〜2*PIで返す
 * @param vec1 {Vec3} THREE.Vector3
 * @param vec2 {Vec3} THREE.Vector3
 * @param isClockwise {boolean} 時計回りを正とするなら真
 * @return {Number} 0〜2*PIまでのラジアン角
**/
const calcAngleAroundYaxis = (vec1, vec2, isClockwise) => {
	const unit1 = vec1.normalize()
	const unit2 = vec2.normalize()
	const angle = (unit1.x * unit2.z - unit2.x * unit1.z > 0) ?
		unit1.angleTo(unit2) : 2 * Math.PI - unit1.angleTo(unit2)

	return (isClockwise === true) ? angle : 2 * Math.PI - angle
}

export default calcAngleAroundYaxis
